import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { initEarly, isPreAuthEntryPage, keycloakReady } from './init-app';
import { mainBackendApolloClient } from '@coverright/data-access/apollo-clients';
import { ApolloProvider } from '@apollo/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './app/app/router';
import 'overlayscrollbars/overlayscrollbars.css';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

function render() {
  root.render(
    <StrictMode>
      <ApolloProvider client={mainBackendApolloClient}>
        <RouterProvider router={router} />
      </ApolloProvider>
    </StrictMode>
  );
}

initEarly().then(async () => {
  if (isPreAuthEntryPage) {
    // Anonymous visitors almost always land here first; don't block their
    // first paint on the keycloak silent-SSO round trip.
    keycloakReady.catch((e) => console.error(e));
    render();
  } else {
    await keycloakReady;
    render();
  }
});
